<template>
  <div>
    <div v-if="loadingData" class="loading">
      <img src="../../../assets/images/icons/loading-pmc.gif" alt="'Loading">
    </div>

    <template v-else>
      <luci-table
        data-test-key="thumbnail-list"
        :loading="loadingData"
        :config="config"
        @add-row-callback="validateThumbnail"
        @delete-row-callback="confirmDeleteThumbnail"></luci-table>
      <paging name="thumbnail-list" :view="view" @page="page"></paging>
    </template>

    <message-modal
      data-test-key="thumbnail-message-modal"
      :open="!!msgModal"
      :title="msgModal ? msgModal.title : null"
      :message="msgModal ? msgModal.message : null"
      @ok-callback="msgModal = null"></message-modal>

    <confirm-modal
      data-test-key="thumbnail-confirm-modal"
      :open="!!confirmModal"
      :title="confirmModal ? confirmModal.title : null"
      :message="confirmModal ? confirmModal.message : null"
      :image="confirmModal ? confirmModal.image : null"
      :item="confirmModal ? confirmModal.item : null"
      @yes-callback="deleteThumbnail"
      @no-callback="confirmModal = null"></confirm-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { isEmpty } from 'lodash'

import MessageModal from '../../modal/MessageModal'
import ConfirmModal from '../../modal/ConfirmModal'
import Paging from '../../shared/paging/Paging'

export default {
  components: { Paging, MessageModal, ConfirmModal },
  props: {
    gameId: String
  },
  created () {
    this.getItems({ gameId: this.gameId })
  },
  data () {
    return {
      msgModal: null,
      confirmModal: null
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'game/thumbnail/list/isLoading',
      error: 'game/thumbnail/list/error',
      view: 'game/thumbnail/list/view',
      items: 'game/thumbnail/list/items',
      getThumbnails: 'game/thumbnail/list/getThumbnails',
      created: 'game/thumbnail/create/created',
      isLoadingCreating: 'game/thumbnail/create/isLoading',
      deleted: 'game/thumbnail/del/deleted',
      isLoadingDeleting: 'game/thumbnail/del/isLoading'
    }),
    loadingData: {
      get () {
        return this.isLoading || this.isLoadingCreating || this.isLoadingDeleting
      }
    },
    displayThumbnails: {
      get () {
        if (!this.loadingData) {
          return this.getThumbnails
        }
        return []
      }
    },
    config: {
      get () {
        return (
          {
            title: 'Thumbnails',
            showSearch: false,
            showButtonEdit: false,
            showButtonDelete: true,
            showButtonAdd: false,
            hideActions: true,
            headers: [
              { text: 'Thumbnail', value: 'data.thumbnail' },
              { text: 'Type', value: 'data.type' },
              { text: '', value: 'actions', width: '50px' }
            ],
            items: [
              ...this.displayThumbnails,
              {
                data: {
                  showButtonDelete: false,
                  showButtonAdd: 'upload',
                  type: null,
                  file: null
                },
                columns: [
                  {
                    field: 'upload',
                    value: null,
                    multipleFiles: false,
                    type: 'file',
                    text: 'Choose File'
                  },
                  {
                    field: 'type',
                    value: null,
                    items: [{ text: 'Thumbnail', value: 'thumbnail' }, { text: 'Cover', value: 'cover' }],
                    type: 'select'
                  }
                ]
              }
            ],
            pagination: { sortBy: 'data.thumbnail' }
          }
        )
      }
    }
  },
  methods: {
    ...mapActions({
      getItems: 'game/thumbnail/list/getItems',
      updateItems: 'game/thumbnail/list/updateItems',
      create: 'game/thumbnail/create/create',
      delete: 'game/thumbnail/del/del'
    }),
    confirmDeleteThumbnail (item) {
      this.confirmModal = { title: 'Delete thumbnail', message: `Do you want to delete this thumbnail?`, image: item.path, item: item }
    },
    deleteThumbnail () {
      const thumbnailId = this.confirmModal.item['@id']
      this.confirmModal = null

      this.delete(thumbnailId).then(() => {
        if (this.error) {
          this.msgModal = {}
        } else {
          this.updateItems({ deleted: this.deleted, gameId: this.gameId })
        }
      })
    },
    validateThumbnail (item) {
      if (item.file !== null && !isEmpty(item.file)) {
        if (['image/jpeg', 'image/jpg', 'image/png'].includes(item.file[0]['type'])) {
          if (['cover', 'thumbnail'].includes(item.type)) {
            this.addThumbnail(item)
          } else {
            this.msgModal = { title: 'Incorrect thumbnail type', message: 'Please select a correct type for a thumbnail.' }
          }
        } else {
          this.msgModal = { title: 'Incorrect image type', message: 'Please upload a <b>jpeg</b>, <b>jpg</b>, or <b>png</b> type image.' }
        }
      } else {
        this.msgModal = { message: 'Please upload an image.' }
      }
    },
    addThumbnail (item) {
      this.create({
        gameId: `/api/games/${this.gameId}`,
        type: item.type,
        thumbnail: item.file[0]
      }).then(() => {
        if (this.error) {
          this.msgModal = {}
        } else {
          this.updateItems({ created: this.created, gameId: this.gameId })
        }
      })
    },
    page (page) {
      this.getItems({ gameId: this.gameId, page: this.view['hydra:' + page] })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~@pm-connect/luci/dist/scss/bootstrap/breakpoints';

  .loading {
    position: relative;
    transform: translate(-15%, 0);

    @include media-breakpoint-up(md) {
      transform: translate(-25%, 0);
      left: calc(50% + 100px); // 100px is width of loading gif

      img {
        width: 100px;
      }
    }
  }
</style>
